// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** родительский блок */

.react-date-picker {
    display: inline-flex;
    position: relative;
}

.react-date-picker,
.react-date-picker *,
.react-date-picker *:before,
.react-date-picker *:after {
    box-sizing: border-box;
}

.react-date-picker--disabled {
    background-color: #f0f0f0;
    color: #6d6d6d;
}


/**родительский блок**/

.react-date-picker__wrapper {
    height: 38px;
    /* width: 180px; */
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    border: thin solid #ccd;
    border-radius: 4px;
}


/** блок даты,  */

.react-date-picker__inputGroup {
    min-width: calc((4px * 3) + 0.54em * 8 + 0.217em * 2);
    flex-grow: 1;
    padding: 0 15px;
    box-sizing: content-box;
}


/** точки у даты */

.react-date-picker__inputGroup__divider {
    padding: 1px 0;
    white-space: pre;
    color: #aaa;
}


/** цифры даты */

.react-date-picker__inputGroup__input {
    min-width: 0.54em;
    height: 100%;
    position: relative;
    padding: 0 1px;
    border: 0;
    color: #aaa;
    background: none;
    font: inherit;
    box-sizing: content-box;
    -moz-appearance: textfield;
}

.react-date-picker__inputGroup__input::-webkit-outer-spin-button,
.react-date-picker__inputGroup__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.react-date-picker__inputGroup__input:invalid {
    background: rgba(255, 0, 0, 0.1);
}

.react-date-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
}


/** блок иконок */

.react-date-picker__button {
    border: 0;
    background: transparent;
    padding: 4px 6px;
}

.react-date-picker__button:enabled {
    cursor: pointer;
}


/** ICONS */

.react-date-picker__button__icon {
    stroke: #999;
    /** цвет иконок */
    stroke-width: 2;
    /** толщина иконок */
}

.react-date-picker__button:enabled:hover .react-date-picker__button__icon,
.react-date-picker__button:enabled:focus .react-date-picker__button__icon {
    stroke: #17a2b8;
}

.react-date-picker__button:disabled .react-date-picker__button__icon {
    stroke: #6d6d6d;
}

.react-date-picker__button svg {
    display: inherit;
}

.react-date-picker__calendar {
    width: 350px;
    max-width: 100vw;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
}

.react-date-picker__calendar--closed {
    display: none;
}


/** табло с выбором даты */

.react-date-picker__calendar .react-calendar {
    border-width: thin;
    border-radius: 14px;
    font-size: 18px;
    font-family: 'Source Sans Pro';
    width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/style/calendarDataPicker.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;;;IAMI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;;AAGA,sBAAsB;;AAEtB;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,kBAAkB;AACtB;;;AAGA,iBAAiB;;AAEjB;IACI,qDAAqD;IACrD,YAAY;IACZ,eAAe;IACf,uBAAuB;AAC3B;;;AAGA,kBAAkB;;AAElB;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;;AAGA,gBAAgB;;AAEhB;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;AACpC;;;AAGA,iBAAiB;;AAEjB;IACI,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;AAGA,WAAW;;AAEX;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;;AAGA,0BAA0B;;AAE1B;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,YAAY;AAChB","sourcesContent":["/** родительский блок */\r\n\r\n.react-date-picker {\r\n    display: inline-flex;\r\n    position: relative;\r\n}\r\n\r\n.react-date-picker,\r\n.react-date-picker *,\r\n.react-date-picker *:before,\r\n.react-date-picker *:after {\r\n    -moz-box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.react-date-picker--disabled {\r\n    background-color: #f0f0f0;\r\n    color: #6d6d6d;\r\n}\r\n\r\n\r\n/**родительский блок**/\r\n\r\n.react-date-picker__wrapper {\r\n    height: 38px;\r\n    /* width: 180px; */\r\n    display: flex;\r\n    flex-grow: 1;\r\n    flex-shrink: 0;\r\n    border: thin solid #ccd;\r\n    border-radius: 4px;\r\n}\r\n\r\n\r\n/** блок даты,  */\r\n\r\n.react-date-picker__inputGroup {\r\n    min-width: calc((4px * 3) + 0.54em * 8 + 0.217em * 2);\r\n    flex-grow: 1;\r\n    padding: 0 15px;\r\n    box-sizing: content-box;\r\n}\r\n\r\n\r\n/** точки у даты */\r\n\r\n.react-date-picker__inputGroup__divider {\r\n    padding: 1px 0;\r\n    white-space: pre;\r\n    color: #aaa;\r\n}\r\n\r\n\r\n/** цифры даты */\r\n\r\n.react-date-picker__inputGroup__input {\r\n    min-width: 0.54em;\r\n    height: 100%;\r\n    position: relative;\r\n    padding: 0 1px;\r\n    border: 0;\r\n    color: #aaa;\r\n    background: none;\r\n    font: inherit;\r\n    box-sizing: content-box;\r\n    -moz-appearance: textfield;\r\n}\r\n\r\n.react-date-picker__inputGroup__input::-webkit-outer-spin-button,\r\n.react-date-picker__inputGroup__input::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n.react-date-picker__inputGroup__input:invalid {\r\n    background: rgba(255, 0, 0, 0.1);\r\n}\r\n\r\n.react-date-picker__inputGroup__input--hasLeadingZero {\r\n    margin-left: -0.54em;\r\n    padding-left: calc(1px + 0.54em);\r\n}\r\n\r\n\r\n/** блок иконок */\r\n\r\n.react-date-picker__button {\r\n    border: 0;\r\n    background: transparent;\r\n    padding: 4px 6px;\r\n}\r\n\r\n.react-date-picker__button:enabled {\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n/** ICONS */\r\n\r\n.react-date-picker__button__icon {\r\n    stroke: #999;\r\n    /** цвет иконок */\r\n    stroke-width: 2;\r\n    /** толщина иконок */\r\n}\r\n\r\n.react-date-picker__button:enabled:hover .react-date-picker__button__icon,\r\n.react-date-picker__button:enabled:focus .react-date-picker__button__icon {\r\n    stroke: #17a2b8;\r\n}\r\n\r\n.react-date-picker__button:disabled .react-date-picker__button__icon {\r\n    stroke: #6d6d6d;\r\n}\r\n\r\n.react-date-picker__button svg {\r\n    display: inherit;\r\n}\r\n\r\n.react-date-picker__calendar {\r\n    width: 350px;\r\n    max-width: 100vw;\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    z-index: 1;\r\n}\r\n\r\n.react-date-picker__calendar--closed {\r\n    display: none;\r\n}\r\n\r\n\r\n/** табло с выбором даты */\r\n\r\n.react-date-picker__calendar .react-calendar {\r\n    border-width: thin;\r\n    border-radius: 14px;\r\n    font-size: 18px;\r\n    font-family: 'Source Sans Pro';\r\n    width: 300px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
